import ResourcePage from "@/components/common/ResourcePage";

export default function FeaturesPage() {
  return (
    <ResourcePage
      title="Features" subtitle="Master feature catalogue mapped to parent modules"
      base="/v1/features" perm="FEATURE"
      columns={[
        { key: "featureCode", header: "Code", render: (r) => <span className="font-mono text-xs font-semibold">{r.featureCode}</span> },
        { key: "featureName", header: "Name" },
        { key: "parentModuleCode", header: "Parent Module", render: (r) => <span className="font-mono text-xs">{r.parentModuleCode}</span> },
        { key: "usageMetric", header: "Usage Metric", render: (r) => r.usageMetric || "—" },
      ]}
      fields={[
        { name: "featureCode", label: "Feature Code", immutable: true },
        { name: "featureName", label: "Feature Name" },
        { name: "description", label: "Description" },
        { name: "parentModuleCode", label: "Parent Module Code", placeholder: "CRM" },
        { name: "usageMetric", label: "Usage Metric (optional)", placeholder: "aiTokens" },
        { name: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
      ]}
    />
  );
}
